import { useTranslation } from '@cobliteam/i18n';
import Typography from '@cobliteam/ui/components/Typography';

type DataTableTotalProps = {
  isLoading: boolean;
  totalRows: number | undefined;
};

const DataTableTotal = ({ isLoading, totalRows }: DataTableTotalProps) => {
  const { t } = useTranslation('ui-business');
  if (isLoading) return null;
  const numberFormatter = Intl.NumberFormat('pt-BR');

  return (
    <Typography color='secondary' variant='text-sm-medium' data-testid='data-table-total'>
      {t('data_table.total')}: <span className='font-normal'>{totalRows && numberFormatter.format(totalRows)}</span>
    </Typography>
  );
};

export default DataTableTotal;
